var _rect, _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_2842",
    "data-name": "Grupo 2842",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1393",
    "data-name": "Ret\\xE2ngulo 1393",
    width: 35,
    height: 35,
    rx: 10,
    fill: "#fff595",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Two-tone_Call",
    "data-name": "Iconly Two-tone Call",
    transform: "translate(8 8)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Call-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stroke_1-126",
    "data-name": "Stroke 1-126"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_316",
    "data-name": "Caminho 316",
    d: "M950.313,392.946c-2.37,0-5.461-1.889-9.186-5.613-3.74-3.738-5.629-6.839-5.616-9.213a3.544,3.544,0,0,1,1.14-2.675c.016-.02.07-.074.089-.092,1.365-1.366,2.258-1.929,3.2-1.906,1.063.013,1.819.809,2.777,1.818.237.249.493.519.778.8a2.812,2.812,0,0,1,.675,3.43c-.345.992-.645,1.848,1.148,3.641s2.649,1.494,3.641,1.145a2.813,2.813,0,0,1,3.431.673c.282.282.548.536.794.77,1.012.964,1.812,1.723,1.825,2.789.01.907-.54,1.833-1.9,3.2l-.6-.409.51.5a3.546,3.546,0,0,1-2.675,1.141Zm-12.559-16.589s-.046.049-.106.108a2.148,2.148,0,0,0-.711,1.662c-.008,1.361.887,3.888,5.2,8.2,4.288,4.288,6.811,5.194,8.176,5.194h.019a2.151,2.151,0,0,0,1.663-.711,2.023,2.023,0,0,1,.163-.154c.946-.953,1.432-1.663,1.427-2.118s-.583-1.012-1.381-1.772c-.255-.242-.53-.5-.821-.794-.755-.753-1.128-.622-1.95-.336-1.137.4-2.694.945-5.121-1.483s-1.883-3.984-1.487-5.121c.287-.821.419-1.2-.337-1.951-.295-.294-.559-.573-.8-.83-.754-.794-1.3-1.368-1.762-1.374h-.007c-.457,0-1.164.487-2.166,1.488Z",
    transform: "translate(-935.512 -373.446)",
    fill: "#fff595"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Stroke_3-102",
    "data-name": "Stroke 3-102",
    transform: "translate(11.274 3.37)",
    opacity: 0.4,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_317",
    "data-name": "Caminho 317",
    d: "M951.406,381.746a.713.713,0,0,1-.7-.577,3.483,3.483,0,0,0-2.765-2.765.714.714,0,0,1,.273-1.4,4.907,4.907,0,0,1,3.893,3.893.714.714,0,0,1-.564.837A.763.763,0,0,1,951.406,381.746Z",
    transform: "translate(-947.364 -376.989)",
    fill: "#fff595"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phoneIcon.3f6005a4deb13a76b76cfe90ee1d5a96.svg";
export { ForwardRef as ReactComponent };